import React from 'react';
import { TextInputField } from 'evergreen-ui';

const TextField = (props: any) => <TextInputField {...props} />;

export default TextField;
